import faqManagementTemplate from './faq-management.html';
import faqCategoryDialogTemplate from '../faq-category-dialog/faq-category-dialog-template.html';
import FaqCategoryDialogController from '../faq-category-dialog/faq-category-dialog-controller';
import faqEntryDialogTemplate from '../faq-entry-dialog/faq-entry-dialog-template.html';
import FaqEntryDialogController from '../faq-entry-dialog/faq-entry-dialog-controller';

const mapStateToThis = ({ session }) => {
  const { locale } = session;

  return {
    locale,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Notifications', 'gettextCatalog')
class FaqManagementController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.onLanguageSelect(this.locale);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  openCategoryDialog() {
    this.Notifications.showComplexDialog({
      template: faqCategoryDialogTemplate,
      bindToController: true,
      controller: FaqCategoryDialogController,
      size: 'md',
      resolve: {
        moduleName: () => 'faqCategory',
        namespace: () => 'faq',
        category: () => {},
        title: () => this.gettextCatalog.getString('Add Category'),
        language: () => this.model.faq.faq.language || this.model.session.locale,
        api: () => this.api.faqDialogApi,
      },
    }).result.then((category) => {
      this.saveCategory.run(category);
    });
  }

  openEntryDialog() {
    this.Notifications.showComplexDialog({
      template: faqEntryDialogTemplate,
      bindToController: true,
      controller: FaqEntryDialogController,
      resolve: {
        moduleName: () => 'faqEntry',
        namespace: () => 'faq',
        entry: () => {},
        title: () => this.gettextCatalog.getString('Create Question'),
        language: () => this.model.faq.faq.language || this.model.session.locale,
        api: () => this.api.faqDialogApi,
        saveEntry: () => this.saveEntry,
      },
    });
  }

  onLanguageSelect(locale) {
    this.model[this.namespace][this.moduleName].language = locale;
  }
}

export default class FaqManagementComponent {
  constructor() {
    this.template = faqManagementTemplate;
    this.controller = FaqManagementController;
    this.bindings = {
      saveCategory: '<',
      saveEntry: '<',
      appCtrl: '<',
      model: '<',
      api: '<',
      namespace: '<',
      moduleName: '<',
    };

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/faq/components/faq-management/faq-management-component.js